import React, { Component, Fragment } from "react";
import isEmpty from "is-empty";
import isWebview from "is-ua-webview";
import Fuse from "fuse.js";

import { closeModal } from "../../shared/components/layouts/OldModal";
import TextInput from "../../shared/components/forms/TextInput";

class ContactManagerExistingContactsList extends Component {
  state = {
    queryString: null,
  };

  get fuse() {
    const options = {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        "email_address",
        "first_name",
        "last_name",
        "work_contact_number",
        "personal_contact_number"
      ],
    };
    return new Fuse(this.unselectedContacts(), options);
  }

  unselectedContacts() {
    return this.props.contacts.filter(contact => {
      return !this.isContactSelected(contact)
    });
  }

  filteredContacts() {
    return !!this.state.queryString ?
      this.fuse.search(this.state.queryString) :
      this.unselectedContacts();
  }

  onKeyDown = (e) => {
    if (e.keyCode !== 13) return; // not return/enter key

    const highlightedContact = this.filteredContacts()[0];
    if (isEmpty(highlightedContact)) return;

    this.addToTradeContacts(highlightedContact)();
  }

  onChange = (field) => {
    return (e) => this.setState({ [field]: e.target.value });
  }

  addToTradeContacts = (tradeContact) => {
    return (e) => {
      e && e.stopPropagation();
      this.props.onAddTradeContact()(tradeContact);
      closeModal();
    };
  }

  isContactSelected(contact) {
    const existingContacts = this.props.tradeContacts.filter(tradeContact => {
      return tradeContact.id === contact.id;
    });

    return existingContacts.length > 0;
  }

  renderAddAsTradeContactButton(index, contact) {
    if (this.isContactSelected(contact)) return;

    return (
      <button 
        className="ds-btn --micro _link _noHover"
        onClick={this.addToTradeContacts(contact)}
      >
        <p className="byline -success">Add Contact</p>
      </button>
    );
  }

  renderTradeContacts() {
    return this.filteredContacts().map((contact, index) => {
      return (
        <li key={index} onClick={this.addToTradeContacts(contact)}>
          <div className="text">
            <p className="copy">{`${contact.first_name} ${contact.last_name}`}</p>
          </div>
          <div className="ds-buttonGroup _spacedButtons _marginBottom--none">
            <button
              className="ds-btn --micro _link _noHover" 
              onClick={this.props.onEditContact(contact)}
            >
              <p className="byline -primary _marginRight--xsmall">Edit Contact</p>
            </button>
            {this.renderAddAsTradeContactButton(index, contact)}
          </div>
        </li>
      );
    })
  }

  renderSearch() {
    return (
      <Fragment>
        { this.props.contacts.length > 0 && (
          <section className="cardSection _noTopPadding">
            <TextInput
              name="search"
              value={this.state.queryString || ""}
              placeholder="Search Contacts"
              autoFocus={!isWebview(navigator.userAgent)}
              onKeyDown={this.onKeyDown}
              onChange={this.onChange("queryString")}
            />
          </section>
        )}
        { this.filteredContacts().length === 0 && (
          <div className="sectionList _empty">
            <ul className="multiLineText">
              <li>
                <p className="byline _alignCenter">No Contacts Available</p>
              </li>
            </ul>
          </div>
        )}
      </Fragment>
    );
  }

  render() {
    return (
      <Fragment>
        <section className="cardSection">
          <button
            data-testid='contacts-list-add-new'
            className="ds-btn --block -success _widthAuto --small"
            onClick={this.props.onTabClick(2)}
          >
            Add New Contact
          </button>
        </section>
        {this.renderSearch()}
        <section className="sectionList">
          <ul>
            {this.props.contacts.length > 0 && ( <li className="listTitle">Available Contacts</li> )}
            {this.renderTradeContacts()}
          </ul>
        </section>
      </Fragment>
    );
  }
}

export default ContactManagerExistingContactsList;



// WEBPACK FOOTER //
// ./src/features/contacts/components/ExistingContactsList.js